import Api from "~/service/Api";

class GuestPaymentRepository {
  getOne(guestPaymentId, query) {
    return Api.get(`/guest-payments/${guestPaymentId}`, query);
  }

  create(data) {
    return Api.post(`/guest-payments`, data);
  }
}

export default GuestPaymentRepository;
